export default "__VITE_ASSET__Bo8FM7lX__"